export default __webpack_public_path__ + "static/neckband_m-aab7ae2d22b01345c4b7f33987f7afa1.png";